import {
  Header,
  TabPanel,
  TableCanceled,
  TableInstalled,
  TableToInstall,
  ModalInstall,
} from "../components/index";
import { PageContextHardwareProvider } from "../context/hardware-provider";

export const LayoutPageHardware = () => (
  <>
    <PageContextHardwareProvider>
      <Header />
      <TabPanel
        moduleToInstallList={<TableToInstall />}
        moduleInstalledList={<TableInstalled />}
        moduleCanceledList={<TableCanceled />}
      />
      <ModalInstall />
    </PageContextHardwareProvider>
  </>
);
